// A designation written out with the day its report was read (B-52), so
// Friday's Questionable never reads as current on a Sunday: "as of Sat". The
// source files no date and is read once a day, so the day is ours. A
// designation the club's roster gives (injured reserve) carries none.

import { dayInZone, type PlayerSummary } from '@fsp/domain';

type Injury = NonNullable<PlayerSummary['injury']>;

/** "as of Sat", or null with no day to say or no zone to say it in yet. */
export function asOfWords(injury: Injury, zone: string | null): string | null {
  if (injury.readAt == null || zone === null) return null;
  return `as of ${dayInZone(injury.readAt, zone, Date.now())}`;
}

/** "Questionable · Hamstring — limited practice · as of Sat", with `joiner` before the note. */
export function injuryWords(injury: Injury, zone: string | null, joiner = ' · '): string {
  const day = asOfWords(injury, zone);
  return `${injury.name}${injury.note ? `${joiner}${injury.note}` : ''}${day ? ` · ${day}` : ''}`;
}
